export default __webpack_public_path__ + "static/media/geral_um.eac03466.jpg";